import {ColDef} from 'ag-grid-community';
import {GridUtils} from './grid-utils';
import {StoreHeaderMenuData} from '../../models-old/ngp-report-grid/header-menu-data';
import {GridHeaderMenuActionTypes} from '../../../shared/shared-models/grid-menu/header-menu-action-types';

export class MenuUtils {

  static onMenuActionEdit(colDef: ColDef, isEditing: boolean): ColDef {
    colDef.editable = isEditing;
    if (isEditing) {
      colDef.type = GridUtils.addColumnTypeCellEdit(colDef);
    } else {
      colDef.type = GridUtils.changeColumnDefinitionType(colDef, 'cellEdit');
    }
    return colDef;
  }

  static updateSortTypeForAllColumns(
    headerMenuState: StoreHeaderMenuData,
    colId: string,
    newSortType: GridHeaderMenuActionTypes.sortAsc | GridHeaderMenuActionTypes.sortDesc | GridHeaderMenuActionTypes.sortUnSort,
    storeId: string
  ): StoreHeaderMenuData {
    const updatedState = {...headerMenuState};
    updatedState[storeId] = {...headerMenuState[storeId]};
    updatedState[storeId][colId] = {
      ...updatedState[storeId][colId],
      sortType: newSortType
    };

    for (const key in updatedState[storeId]) {
      if (updatedState[storeId].hasOwnProperty(key)) {
        if (key !== colId && updatedState[storeId]?.[key]?.sortType !== null) {
          updatedState[storeId][key] = {
            ...updatedState[storeId][key],
            sortType: 'sort-unsort'
          };
        }
      }
    }

    return updatedState;
  }

}
